export default {
  title: 'GQ X FightCamp Trackers',
  id: 'gq_fightcamp_trackers',
  price: 15800,
  affirmPrice: 0,
  oldPrice: 0,
  monthly: 0,
  months: 0,
  category: 'package',
  path: '/shop/gq/fightcamp-trackers/',
  internalPath: 'shop/gq/fightcamp-trackers/',
  img_url: 'https://cdn3.joinfightcamp.com/1000x0/v4/fc-fightcamp-base-001.png',
  description: 'Our essentials package',
  fbid: '',
  gmc_id: '',
};